import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useStore } from '../../store';
import { useNavigate, Link } from 'react-router-dom';
import SRFButton from '../Inputs/SRFButton/SRFButton';
import { getLastSyncCheck } from '../../Utils/Functions/Dexie-Setup';

export const version = "1.3.2";


function Settings() {
  const { isAuthed, isOnline, language, setLanguage, hours, setHours, setSettingsVisited, signOut, isSpanish, fetchAndStoreAllTables, translation = {} } = useStore();
  const navigate = useNavigate();
  const [refreshing, setRefreshing] = useState(false);
  const [lastSynced, setLastSynced] = useState(100);
  const changeLanguage = useCallback((e) => setLanguage(e.target.value));
  const changeHours = useCallback((e) => {
    let num = Number(e.target.value);
    if (!num && num !== 0) {
      num = null;
    }
    if (num) {
      if (num < 0) {
        num = 0;
      } else if (num > 4300) {
        num = 4300
      }
    }
    setHours(Math.floor(num))
  });
  useEffect(() => {
    if (!isAuthed) {
      navigate("/auth")
    }
  }, [isAuthed])

  useEffect(() => {
    getLastSyncCheck().then(newTime => setLastSynced(newTime));
  })
  return (
    <div className='flex flex-col items-center pt-4 gap-2'>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <Link to="/" >
          <SRFButton color='#0f314d'>{translation.home}</SRFButton>
        </Link>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4 flex sm:flex-row sm:gap-3 gap-2 flex-col'>
        <div className='flex flex-row gap-1 grow'>
          <label className={`${language === "en" ? "shadow-md shadow-slate-400" : "shadow-sm hover:shadow-md"}  active:shadow-inner active:shadow-slate-200 bg-white flex flex-row gap-1 w-full rounded-lg px-4 items-center py-3 transition-shadow duration-200 cursor-pointer`} htmlFor={`enLangInput`}>
            <input className='cursor-pointer' onChange={changeLanguage} checked={language === "en"} type="radio" id={`enLangInput`} name={`langInput`} value={"en"} />
            <p className='drop-shadow-sm'>
              English
            </p>
          </label>
        </div>
        <div className='flex flex-row gap-1 grow'>
          <label className={`${language === "es" ? "shadow-md shadow-slate-400" : "shadow-sm hover:shadow-md"}  active:shadow-inner active:shadow-slate-200 bg-white flex flex-row gap-1 w-full rounded-lg px-4 items-center py-3 transition-shadow duration-200 cursor-pointer`} htmlFor={`esLangInput`}>
            <input className='cursor-pointer' onChange={changeLanguage} checked={language === "es"} type="radio" id={`esLangInput`} name={`langInput`} value={"es"} />
            <p className='drop-shadow-sm'>
              Español
            </p>
          </label>
        </div>
      </div>
      <div className="lg:w-1/3 md:w-1/2 w-full px-4">
        <label htmlFor={"hoursField"} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{translation.hoursToStaySignedIn}</label>
        <input value={hours ?? ""} inputMode='numeric' onChange={changeHours} type="text" id={`hoursField`} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <a href='/atlas-dfrs/reset2.html' >
          <SRFButton color='#0f314d'>{translation.getMostRecentAppVersion}</SRFButton>
        </a>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <SRFButton onClick={() => window.location.reload()} color='#0f314d'>{translation.refreshPage}</SRFButton>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <SRFButton disabled={refreshing || !isOnline} onClick={() => { setRefreshing(true); fetchAndStoreAllTables().then(() => setRefreshing(false)) }} color='#0f314d'>{translation.refreshData}</SRFButton>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <SRFButton onClick={() => window.confirm(translation.confirmLogout) ? signOut() : null} color='#0f314d'>{translation.logout}</SRFButton>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <span style={{ color: "rgba(0, 0, 0, 0.5)" }} >{translation.dataLastSynced}: {new Date(lastSynced).toLocaleString()}</span>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <span style={{ color: "rgba(0, 0, 0, 0.5)" }} >{translation.version}: {version}</span>
      </div>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <span style={{ color: "rgba(0, 0, 0, 0.8)" }} >{isOnline ? `🟢 ${translation.online}` : `🔴 ${translation.offline}`}</span>
      </div>

    </div>
  )
}

export default Settings;
